export const canReadCallHistory = (roleUid, user) => {
    if (['admin', 'superAdmin'].includes(roleUid)) return true;
    if (roleUid !== 'support') return false;
    return [user?.teamId?.name, user?.teamId?.title, user?.team?.name, user?.team?.title, user?.teamName].some(name => typeof name === 'string' && ['customer support', 'soporte al cliente'].includes(name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase()));
};
export const panamaDay = (now = new Date()) => {
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Panama', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
    const part = key => parts.find(p => p.type === key).value;
    return `${part('year')}-${part('month')}-${part('day')}`;
};
const shift = (day, n) => new Date(Date.parse(`${day}T12:00:00Z`) + n * 86400000).toISOString().slice(0, 10);
export const presetDates = (preset, now = new Date()) => {
    if (preset === 'all') return { from: '', to: '' };
    const today = panamaDay(now);
    if (preset === 'today') return { from: today, to: today };
    if (preset === 'previousWeek') {
        const day = new Date(`${today}T12:00:00Z`).getUTCDay();
        const monday = shift(today, -((day + 6) % 7));
        return { from: shift(monday, -7), to: shift(monday, -1) };
    }
    return { from: shift(today, -6), to: today };
};
export const callDuration = call => {
    if (!call?.startedAt || !call?.endedAt) return null;
    const seconds = Math.round((Date.parse(call.endedAt) - Date.parse(call.startedAt)) / 1000);
    if (!Number.isFinite(seconds) || seconds < 0) return null;
    return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
};
